"use strict";

var devHandler = function devHandler(_ref, _ref2) {
  var _window$analytics;

  var location = _ref.location;
  var eventName = _ref2.eventName;

  if (!window.analytics || typeof window.analytics.page !== "function") {
    console.warn("Unable to locate analytics.js");
    return;
  }

  var args = [{
    path: location.pathname
  }];
  if (eventName) args.unshift(eventName); // This doesn't mimic the call to page, but it is more informative

  (_window$analytics = window.analytics).page.apply(_window$analytics, args);
};

var prodHandler = function prodHandler(_, _ref3) {
  var eventName = _ref3.eventName;
  window.analytics && window.analytics.page(eventName);
};

exports.onRouteUpdate = process.env.NODE_ENV === "production" ? prodHandler : devHandler;